export default "__VITE_ASSET__CQqIDapH__"